/* cart-custom.js – toast, contador, meta de frete grátis, fechar drawer */
document.addEventListener("DOMContentLoaded", () => {
  /* ---------- Toast ---------- */
  const toast = document.getElementById("add-to-cart-toast");
  const msgBox = toast.querySelector(".toast-message");
  const goalBox = toast.querySelector('[data-item="freeshipping-goal"]');

  const showToast = () => {
    toast.classList.remove("d-none", "fade-out");
    toast.style.opacity = "1";
    msgBox.style.opacity = "1";
    
    setTimeout(()=> toast.classList.add('fade-out'), 5000);
  };

  /* ---------- Free-shipping Goal ---------- */
  const normaliseCents = (v) => (v < 1000 ? v * 100 : v); // “150” → “15000”

  const updateFreeShippingGoal = (cart) => {
    if (!goalBox) return;

    /* --- valores em centavos --- */
    let goal = parseInt(goalBox.dataset.goal, 10) || 0;
    goal = normaliseCents(goal);
    if (goal === 0) return; // meta não configurada

    const subtotal = cart.total_price;
    const needMore = Math.max(0, goal - subtotal); // nunca negativo

    /* --- elementos --- */
    const msg1 = goalBox.querySelector(".msg-1");
    const msg2 = goalBox.querySelector(".msg-2");
    const bar = goalBox.querySelector(".cart-goal__bar > span");
    const badge = goalBox.querySelector(".goal-badge");

    /* --- guarda o template original apenas 1x --- */
    if (!msg1.dataset.template) msg1.dataset.template = msg1.innerHTML;

    /* --- substitui todos placeholders possíveis --- */
    const formatted = Shopify.formatMoney(needMore);
    msg1.innerHTML = msg1.dataset.template
      .replace(/{{\s*amount\s*}}/gi, formatted)
      .replace(/\[amount]/gi, formatted)
      .replace(/{{\s*valor\s*}}/gi, formatted)
      .replace(/\[valor]/gi, formatted);

    /* --- barra de progresso --- */
    const pct = Math.min(100, Math.round((subtotal / goal) * 100));
    bar.style.width = pct + "%";

    /***** badge “%” *****/
    if (badge) {
      badge.textContent = pct; // texto
      badge.dataset.progress = pct + "%"; // se CSS usa data-progress
    }

    /* --- alterna mensagens --- */
    if (needMore > 0) {
      msg1.classList.remove("d-none");
      msg2.classList.add("d-none");
    } else {
      msg1.classList.add("d-none");
      msg2.classList.remove("d-none");
    }

    goalBox.classList.remove("d-none"); // garante visível
  };

  /* ---------- Cabeçalho ---------- */
  const updateHeaderCart = (cart) => {
    const show = cart.item_count > 0;
    document
      .querySelectorAll("[data-cart-count], .cart-icon .count")
      .forEach((el) => {
        el.textContent = cart.item_count;
        el.setAttribute("data-cart-count", cart.item_count);
        el.classList.toggle("d-none", !show);
        el.style.display = show ? "" : "none";
      });

    document
      .querySelectorAll(".cart-total-header")
      .forEach(
        (el) => (el.textContent = Shopify.formatMoney(cart.total_price))
      );

    updateFreeShippingGoal(cart); // barra + mensagens
  };

  /* ---------- Add-to-Cart ---------- */
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-add-to-cart");
    if (!btn) return;

    e.preventDefault();
    const id = btn.dataset.variantId;
    const qty = btn.dataset.qty || 1;

    try {
      const add = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id, quantity: qty }),
      });
      if (!add.ok) throw new Error(await add.text());

      const cart = await fetch("/cart.js").then((r) => r.json());
      updateHeaderCart(cart);
      showToast();
    } catch (err) {
      window.location.href = btn.href; // fallback
    }
  });

  /* ---------- Fecha drawer automático ---------- */
  const minicart = document.getElementById("cart-notification");
  if (minicart) {
    new MutationObserver(() => {
      minicart.style.display = "none";
    }).observe(minicart, { attributes: true, childList: true });
  }
});
